import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Logger, LoggingService, LogLevel } from '../logging/logging.service';
import { CurafidaAuthService } from '../authentication/curafida-auth.service';
import { SplashScreenStateService } from '../common/services/splash-screen-state.service';

@Injectable({
    providedIn: 'root',
})
export class LoginGuardService {
    protected readonly authService = inject(CurafidaAuthService);
    private readonly router = inject(Router);
    private readonly loggingService = inject(LoggingService);
    private readonly splashScreenStateService = inject(SplashScreenStateService);
    protected readonly log: Logger = this.loggingService.getLogger('LoginGuardService');

    constructor() {
        this.log.setLevel(LogLevel.DEBUG);
    }

    async canActivate(): Promise<UrlTree | boolean> {
        // A session whose access token merely expired is revived instead of shown the login page.
        const isAuthenticated =
            this.authService.isAuthenticated() || (await this.authService.ensureFreshToken('login guard'));
        if (isAuthenticated) {
            this.log.debug(`[canActivate] User is already authenticated. Navigate to root /`);
            return this.router.parseUrl('/');
        }
        this.log.info(`[canActivate] User is NOT authenticated. Stay on /login and return true.`);
        this.splashScreenStateService.splashScreenIsEnabled.set(false);
        return true;
    }
}
